import styled from "styled-components";

export const UpdatedAt = styled.div`
  font-size: 12.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const CancellationReason = styled.div`
  font-size: 12.5px;
  color: #c0392b;
  font-family: ${(p) => p.theme.tokens.font.family};
  margin-top: 4px;
`;
